import { atom, selector } from "recoil";

export const loginState = atom<boolean>({
  key: "loginState",
  default: false
});

// 런처
export const isLauncherState = atom<boolean>({
  key: "isLauncherState",
  default: false
});

export const isLauncherLoginSelector = selector({
  key: "isLauncherLoginSelector",
  get: ({ get }) => {
    const isLauncher = get(isLauncherState);
    const login = get(loginState);

    return isLauncher && !login;
  }
});
